import { CountryPicker, ExternalLink, WrapperEntitySelector } from '@components/Inputs';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { Grid, TextInput, Accordion } from '@ts/storybook';
import { CUser, CPerson, CPersonData, IForm } from '@ts/ui-models';

interface PersonDataAccordionProps extends IForm {
  idLinked?: string;
  linkToUser?: boolean;
  linkToPerson?: boolean;
  isViewMode: boolean;
  personData?: CPersonData | null;
}

const PersonDataAccordion = (props: PersonDataAccordionProps) => {
  const { idLinked, linkToPerson, linkToUser, isViewMode, personData, requiredFields, onChange, onCallbackChange } = props;

  //UserForm field in the rootObject
  const fieldObject = linkToPerson ? '' : linkToUser ? 'flavors.person.personData.' : '';

  //#region Handlers

  const handleChangePerson = entity => {
    const newPersonData: CPersonData | null = linkToPerson && entity ? new CPerson(entity).getPersonData() : null;

    if (newPersonData) {
      onChange('personDataId', newPersonData.getID());
      onChange(fieldObject, newPersonData);
      onChange('userPersonData', newPersonData);
    } else {
      onChange('personDataId', null);
    }
    const value = entity ? entity.getID() : null;
    onChange('person', entity);
    onChange('personId', value);
  };
  const handleChangeUser = entity => {
    const newPersonData: CPersonData | null = linkToUser && entity ? new CUser(entity).getPersonData() : null;

    if (newPersonData) {
      onChange('flavors.person.userId', entity.getID());
      onChange('flavors.person.personData', newPersonData);
      onChange(fieldObject + 'user', entity);
    } else {
      onChange('flavors.person.userId', null);
      onChange(fieldObject + 'user', null);
    }
  };

  //#endregion

  return (
    <Accordion title="Person data" open={!isViewMode}>
      <Grid container spacing={1} direction={'column'}>
        {((isViewMode && personData?.id) || !isViewMode) && linkToPerson && (
          <WrapperEntitySelector
            label={idLinked ? 'Linked to Person' : ['Optional', ': ', 'Link to Person']}
            value={personData?.person?.id}
            onChangeEntity={v => handleChangePerson(v)}
            searchComponent={generateSearchEntitySelector('people')}
            isReadOnly={isViewMode}
          />
        )}
        {((isViewMode && personData?.id) || !isViewMode) && linkToUser && (
          <WrapperEntitySelector
            label={idLinked ? 'Linked to User' : ['Optional', ': ', 'Link to User']}
            value={personData?.user}
            onChangeEntity={v => handleChangeUser(v)}
            searchComponent={generateSearchEntitySelector('user')}
            isReadOnly={isViewMode}
          />
        )}
        <TextInput
          isReadOnly={Boolean(isViewMode || personData?.user)}
          label="First name"
          value={personData?.firstName}
          onChangeValue={onCallbackChange(fieldObject + 'firstName')}
          required={requiredFields?.includes('firstName')}
        />
        <TextInput
          isReadOnly={Boolean(isViewMode || personData?.user)}
          label="Family name"
          value={personData?.familyName}
          onChangeValue={onCallbackChange(fieldObject + 'familyName')}
          required={requiredFields?.includes('familyName')}
        />
        {((isViewMode && personData?.countryId) || !isViewMode) && (
          <CountryPicker
            label="Country of origin"
            value={personData?.countryId}
            onChange={onCallbackChange(fieldObject + 'countryId')}
            isReadOnly={Boolean(isViewMode || personData?.user)}
          />
        )}
        <ExternalLink
          onChangeLink={onCallbackChange(fieldObject + 'externalHttpLink')}
          onChangeCaption={onCallbackChange(fieldObject + 'externalHttpLinkCaption')}
          url={personData?.externalHttpLink ?? ''}
          caption={personData?.externalHttpLinkCaption ?? ''}
          isReadOnly={Boolean(isViewMode || personData?.user)}
          viewFields={!isViewMode}
        />
      </Grid>
    </Accordion>
  );
};
export default PersonDataAccordion;
